import moment from 'moment';

export const formatDate = (timestamp) => {
    if (!timestamp) return "";
    return moment.unix(timestamp).format("DD-MM-YYYY");
};

export const formatDateWithTime = (timestamp) => {
    if (!timestamp) return "";
    return moment.unix(timestamp).format("DD-MM-YYYY HH:mm:ss A");
};


export const formatDateWithTimeWithoutSec = (timestamp) => {
    if (!timestamp) return "";
    return moment.unix(timestamp).format("DD-MM-YYYY HH:mm A");
};



export const formatLatestDate = (timestamp) => {
    if (!timestamp) return "";

    const date = moment.unix(timestamp);
    const today = moment().startOf("day");
    const yesterday = moment().subtract(1, "day").startOf("day");

    if (date.isSame(today, "d")) {
        return "Today";
    } else if (date.isSame(yesterday, "d")) {
        return "Yesterday";
    } else {
        return date.format("DD-MM-YYYY");
    }
};
